export default function addMediaListener(mediaQuery, callBack) {
    const mq = window && window.matchMedia(mediaQuery),
        handler = () => callBack(mq);

    mq.addListener(handler);

    callBack(mq);

    return () => mq.removeListener(handler);
}



// WEBPACK FOOTER //
// ./src/utils/mediaListener.js